import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-page-hero-header',
    templateUrl: './eui-page-hero-header.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiPageHeroHeaderComponent {

    @Input() label;
    @Input() subLabel;

    @HostBinding('class')
    get cssClasses() {
        return [
            `eui-page-hero-header`,
        ].join(' ').trim();
    }

    constructor(

    ) {
    }

}
